const economicInvestigationRouter = {
  path: '/',
  component: () => import('@/layout'),
  children: [
    {
      path: '/economicInvestigation', // 经侦
      name: 'economicInvestigation',
      component: () =>
        import(/* webpackChunkName: "economic-investigation" */ '@/pages/economicInvestigation'),
      redirect: 'economicInvestigation/main',
      children: [
        {
          path: 'main',
          name: 'main',
          meta: { title: '经侦贸易预警' },
          component: () =>
            import(
              /* webpackChunkName: "economic-investigation" */ '@/pages/economicInvestigation/main'
            )
        },
        {
          path: 'listIndex',
          name: 'listIndex',
          meta: { title: '经侦贸易预警' },
          component: () =>
            import(
              /* webpackChunkName: "economic-investigation" */ '@/pages/economicInvestigation/list/listIndex'
            )
        },
        {
          path: 'marketcreditList',
          name: 'marketcreditList',
          meta: { title: '信用评价及查询' },
          component: () =>
            import(
              /* webpackChunkName: "economic-investigation" */ '@/pages/economicInvestigation/list/marketcreditList'
            )
        },
        {
          path: 'content/:id',
          name: 'economicInvestigationContent',
          meta: { title: '最新预警信息' },
          component: () =>
            import(
              /* webpackChunkName: "economic-investigation" */ '@/pages/economicInvestigation/content'
            )
        },
        {
          path: 'marketcredit/:id',
          name: 'marketcredit',
          meta: { title: '最新预警信息' },
          component: () =>
            import(
              /* webpackChunkName: "economic-investigation" */ '@/pages/economicInvestigation/content/marketcredit'
            )
        }
      ]
    },
    {
      path: 'report/suspicious', // 可疑填报
      name: 'suspicious',
      meta: { title: '可疑填报' },
      component: () =>
        import(
          /* webpackChunkName: "economic-investigation" */ '@/pages/economicInvestigation/report/suspicious'
        )
    },
    {
      path: 'report/economicCrime', // 经济犯罪
      name: 'economicCrime',
      meta: { title: '经济犯罪' },
      component: () =>
        import(
          /* webpackChunkName: "economic-investigation" */ '@/pages/economicInvestigation/report/economicCrime'
        )
    },
    {
      path: 'report/dishonesty', // 失信行为
      name: 'dishonesty',
      meta: { title: '失信行为' },
      component: () =>
        import(
          /* webpackChunkName: "economic-investigation" */ '@/pages/economicInvestigation/report/dishonesty'
        )
    }
  ]
}

export default economicInvestigationRouter
